if (document.querySelector('.select-tag')) {
  document.querySelectorAll(".select-tag").forEach((element) => {
    if (!element.tomselect) {
      const max = element.dataset.maxselected ? element.dataset.maxselected : 3;

      new TomSelect(element, {
        maxItems: max,
        plugins: {
          dropdown_input: {},
          remove_button:{
            title:'Supprimer ce tag',
          }
        },
        render: {
          no_results: function () {
            return '<span>Aucun résultat</span>';
          }
        }
      });
    }
  });
}

//application de tom select à toutes les listes déroulantes simples
/*if (document.querySelector('select:not(.select-tag):not(.dropdownListOfFilter)')) {
  document.querySelectorAll("select:not(.select-tag):not(.dropdownListOfFilter)").forEach((element) => {
    new TomSelect(element,{
      render: {
        no_results: function () {
          return '<span>Aucun résultat</span>';
        }
      }
    });
  });
}*/

window.initTomSelectField = function(selector, options = {}) {
  if (document.querySelector(selector)) {
    return new TomSelect(selector, options);
  }
}
